//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    scrollToTop: true,
    data() {
        return {
            contentItems: 5,
        };
    },
    head: {
        meta: [
            {
                hid: 'og:title',
                name: 'og:title',
                content: 'Responsible Disclosure',
            },
        ],
        title: 'Responsible Disclosure',
    },
};
